import axios from 'axios'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import endpoint from '@src/data/endpoint.json'
import store from '@state/store'

const { Validator } = VeeValidate

const isUnique = (value) => {
  return axios
    .post(endpoint.member.checkEmail, {
      email: value,
      propertyId: store.getters['app/propertyId'],
    })
    .then((response) => {
      return {
        valid: response.data.valid,
        data: {
          message: 'The email address is not available.',
        },
      }
    })
}

Validator.extend('unique', {
  validate: isUnique,
  getMessage: (field, params, data) => {
    return data.message
  },
})

Vue.use(VeeValidate, { inject: false })
